import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function ProductPresentation() {
  return <section className="py-24 bg-amber-900 text-amber-50 overflow-hidden" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <span className="inline-block py-1 px-3 rounded-full bg-amber-800 text-amber-200 text-sm font-semibold mb-4 border border-amber-700" data-id="element-202">
            PRESENTANDO
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 font-serif" data-id="element-203">
            Quincena Milagrosa
          </h2>
          <p className="text-xl md:text-2xl text-amber-200 max-w-3xl mx-auto" data-id="element-204">
            10 Hacks para que tu Sueldo Rinda (sin vivir a base de atún)
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-205">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative flex justify-center lg:justify-end" data-id="element-206">
            <div className="absolute inset-0 bg-amber-500/20 blur-[100px] rounded-full" data-id="element-207" />
            <img src="https://cdn.magicpatterns.com/uploads/q4Vp5WLEeVtKRxmNFZiqpW/PORTADA_-_EBOOK.png" alt="Portada del Ebook Quincena Milagrosa" className="relative z-10 w-full max-w-md shadow-2xl rounded-lg transform hover:scale-105 transition-transform duration-500" data-id="element-208" />
          </motion.div>

          {/* Product Details */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-209">
            <div className="prose prose-lg prose-invert text-amber-100/90" data-id="element-210">
              <p data-id="element-211">
                Es un ebook práctico, directo y accionable que te enseña a tomar
                control de tu quincena sin estrés ni culpa.
              </p>
              <p data-id="element-212">
                No es teoría financiera. No es motivación barata. No es un
                método gringo que no encaja con nuestra realidad.{' '}
                <strong className="text-white" data-id="element-213">Es vida real.</strong>
              </p>
            </div>

            <div className="bg-amber-950/50 p-8 rounded-2xl border border-amber-800" data-id="element-214">
              <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-215">
                <Star className="w-5 h-5 text-amber-400 fill-current" data-id="element-216" />
                Dentro vas a aprender a:
              </h3>
              <ul className="space-y-4" data-id="element-217">
                {['Tapar las fugas invisibles de dinero', 'Organizar tu quincena sin sentirte limitada', 'Gastar con control sin sabotearte', 'Llegar tranquila a fin de quincena sin vivir contando pesos'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-218">
                    <div className="bg-amber-500/20 p-1 rounded-full mt-0.5" data-id="element-219">
                      <Check className="w-4 h-4 text-amber-400" data-id="element-220" />
                    </div>
                    <span className="text-amber-100" data-id="element-221">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-wrap gap-4 text-sm font-medium text-amber-300" data-id="element-222">
              <span className="flex items-center gap-1.5 bg-amber-900/50 px-3 py-1.5 rounded-full border border-amber-800" data-id="element-223">
                ✔ Aplicarse rápido
              </span>
              <span className="flex items-center gap-1.5 bg-amber-900/50 px-3 py-1.5 rounded-full border border-amber-800" data-id="element-224">
                ✔ Verse reflejado en la misma quincena
              </span>
              <span className="flex items-center gap-1.5 bg-amber-900/50 px-3 py-1.5 rounded-full border border-amber-800" data-id="element-225">
                ✔ Reducir la ansiedad casi de inmediato
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}